module.exports = __webpack_public_path__ + "static/media/banner.d6d6dbf4.png";